<template>
  <div>
    <div v-for="(filter, key) in filters" :key="key" class="control">
      <label class="checkbox noselect"
        :for="getUniqueId(key)">
        <input type="checkbox"
          @change.stop="updateFieldValue($event)"
          :value="filter.value"
          :id="getUniqueId(key)"
          :name="`${getName(key)}[]`"
          :checked="isChecked(filter.value)">
        <span class="check"></span>
        <span class="control-label">{{ filter.display }}</span>
      </label>
    </div>
  </div>
</template>

<script>
  import { parseValue } from '@/utility/utility_functions'

  export default {
    name: 'table-filter-list-component',
    data () {
      return {
        allValues: []
      }
    },
    props: {
      uid: {
        type: String,
        default: ''
      },
      filters: {
        type: Array,
        required: true
      },
      selected: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      getFilterClass () {
        return {
          ' mdi-filter': this.allValues.length,
          ' mdi-filter-outline': !this.allValues.length
        }
      }
    },
    methods: {
      getName (index) {
        return `filter-checkbox${this.uid}${index}`
      },
      getUniqueId (index) {
        return `filter-checkbox${this.uid}${index}`
      },
      isChecked (value) {
        return this.selected.length && this.selected.includes(value)
      },
      updateFieldValue (event) {
        let val = parseValue(event.target.value)
        // remove any existing values from the array
        this.allValues = this.allValues.filter(value => {
          return value !== val
        })
        // add value only if checked
        if (event.target.checked) {
          this.allValues.push(val)
        }
        // send value to containing parent
        this.$emit('setSelectedFilters', this.allValues)
      }
    },
    created () {
      this.allValues = this.allValues.concat(this.selected)
    }
  }
</script>
<style lang="sass" scoped>
  label.checkbox
    min-width: 15rem
</style>
